import { Trans } from "@lingui/macro";
import { Box, useMediaQuery } from "@mui/material";
import { ThemedText } from "src/theme/text";
import styled from "styled-components";
import AssetList from "./AssetList";
import { useMemo } from "react";
import { formatAmount2 } from "src/helpers/Helpers";
import { useSelector } from "react-redux";
import { BN } from "src/utils/bn";
import { useGetVyroPrice } from "src/hooks/get_price_vyro";
import AssetListM from "./AssetListM";
import {
  useBalance_VYRO,
  useBalance_esVYRO,
  useBalance_usdc,
} from "src/hooks/useQueryEarn";
import { ReactComponent as AssetsIcon } from "src/assets/images/titles/assets.svg";

const AssetBox = styled(Box)`
  width: 100%;
  .titleBox {
    padding-bottom: 48px;
    border-bottom: 1px solid ${({ theme }) => theme.bg4};
  }
`;

export default function Asset() {
  const isSmallScreen = useMediaQuery("(max-width: 1180px)");
  const VYROPrice = useGetVyroPrice();
  const usdcBalance = useBalance_usdc();
  const VYROBalance = useBalance_VYRO();
  const VYROStaked = 0;
  const esVYROBalance = useBalance_esVYRO();
  const esVYROStaked = 0;
  const tokensArr = useSelector((state: any) => {
    return state?.app?.tokensArr || [];
  });
  const totalAmount = useMemo(() => {
    if (
      VYROBalance == undefined ||
      VYROStaked == undefined ||
      esVYROBalance == undefined ||
      esVYROStaked == undefined ||
      VYROPrice == undefined ||
      usdcBalance == undefined ||
      tokensArr.length == 0
    )
      return;
    const vyroAmount = VYROBalance.plus(VYROStaked).times(VYROPrice);
    const esVYROAmount = esVYROBalance.plus(esVYROStaked).times(VYROPrice);
    const dlpAmount = tokensArr.reduce((pre, curr) => {
      const { dlpBalance, dlpBalanceStaked, price } = curr;
      pre = pre.plus(BN(dlpBalance).plus(dlpBalanceStaked).times(price));
      return pre;
    }, BN(0));

    return dlpAmount.plus(vyroAmount).plus(esVYROAmount).plus(usdcBalance);
  }, [
    VYROBalance,
    VYROStaked,
    esVYROBalance,
    esVYROStaked,
    VYROPrice,
    usdcBalance,
    tokensArr,
  ]);
  return (
    <AssetBox className="asset-view">
      <Box display="flex" justifyContent="center" className="titleBox">
        <div className="container">
          <AssetsIcon />
          {/* <ThemedText.Title color="primaryText1">
            <Trans>Asset</Trans>
          </ThemedText.Title> */}
          <Box
            display="flex"
            alignItems="center"
            justifyContent="space-between"
            mt="36px"
          >
            <div className="">
              <ThemedText.Text4Bold>
                <Trans>Total Value</Trans>
              </ThemedText.Text4Bold>
              <ThemedText.Text1Bold mt="2px" fontSize={36}>
                ${formatAmount2(totalAmount, 2, true)}
              </ThemedText.Text1Bold>
            </div>
            {/* <TokensPercentage /> */}
          </Box>
        </div>
      </Box>
      <Box display="flex" justifyContent="center">
        <div className="container">
          {isSmallScreen ? <AssetListM /> : <AssetList />}
        </div>
      </Box>
    </AssetBox>
  );
}
